import { Injectable } from '@angular/core';
import { VehicleRepository } from '@data/repository/vehicle/vehicle.repository';
import { VehicleEntity } from '@domain/dto/vehicle/vehicle-get.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleUsecase {
  constructor(private repository: VehicleRepository) {}

  get(params: any): Observable<VehicleEntity> {
    return this.repository.get(params);
  }
}
